import { Stack, Typography } from "@mui/material";
import PivotExpansionButton from "../../../viewer/pivot/PivotExpansionButton.tsx";

interface Props {
  allExpanded: boolean;
  onToggleAll: () => void;
}

const FieldsTitle = ({ allExpanded, onToggleAll }: Props) => (
  <Stack direction="row" sx={{ alignItems: "center" }}>
    <PivotExpansionButton
      all
      expanded={allExpanded}
      onToggle={onToggleAll}
      label={allExpanded ? "Collapse all" : "Expand all"}
    />
    <Typography variant="subtitle1" color="textPrimary">
      Fields
    </Typography>
  </Stack>
);

export default FieldsTitle;
